import { sessionState } from 'appConstants';

// This is the initial state for the entire app
export const initialState = {
  isAdding: false,
  addForm: true,
  candidate: { availableChannels: [] },
  isInChat: false,
  isLoadingMsgs: false,
  isSendingMsg: false,
  isAnonymous: false,
  isAnonInitializing: false,
  isChatWidgetOpen: false,
  unreadMsgsCount: 0,
  messages: [],
  availableChannels: [],
  resumeUploaded: false,
  initialAriMessageObj: {},

  // This is the initial state for the session
  // Active: user is in a chat session
  // Inactive: user has not engaged with the chat widget
  // Failed: token has expired or there's a network issue
  state: sessionState.INACTIVE,
};
